var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendTransactionInitiationEmailsGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_7927)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_7927",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_7927)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27_7927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.0234C38.2678 49.0234 49.0234 38.2678 49.0234 25C49.0234 11.7322 38.2678 0.976562 25 0.976562C11.7322 0.976562 0.976562 11.7322 0.976562 25C0.976562 38.2678 11.7322 49.0234 25 49.0234Z",
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_27_7927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6452 36.3019H11.6401C10.8656 36.3033 10.1078 36.077 9.46087 35.6511C8.81396 35.2252 8.30655 34.6185 8.00176 33.9065C7.79603 33.4239 7.69044 32.9045 7.69141 32.3799V16.6916C7.69103 16.1758 7.79307 15.665 7.99162 15.1889C8.19017 14.7128 8.48128 14.2809 8.84805 13.9182C9.58993 13.1807 10.5941 12.7676 11.6401 12.7695H35.3326C36.1071 12.7682 36.8649 12.9945 37.5117 13.4205C38.1586 13.8464 38.6659 14.4531 38.9707 15.165C39.1764 15.6476 39.282 16.167 39.2811 16.6916V30.5252C38.6858 30.1551 38.0066 29.9416 37.3066 29.9045V16.6916C37.2978 16.4965 37.2588 16.304 37.1909 16.1209L28.833 23.2354L35.1307 30.3838C34.5439 30.6968 34.0406 31.1459 33.663 31.6934L27.3349 24.5106L24.1284 27.2396C23.9496 27.3929 23.7219 27.4771 23.4864 27.4771C23.2509 27.4771 23.0231 27.3929 22.8443 27.2396L19.6379 24.5107L11.0771 34.2274L11.0941 34.2326C11.2697 34.2956 11.4538 34.3318 11.6401 34.34H32.9566C33.0133 35.0421 33.2505 35.7175 33.645 36.3009L33.6452 36.3019ZM9.78243 16.1209L9.77989 16.129C9.71305 16.3095 9.67457 16.4992 9.66583 16.6915V32.3799C9.66941 32.4685 9.68519 32.5563 9.7127 32.6406C9.72374 32.6805 9.73516 32.7215 9.74395 32.763L18.1379 23.2335L9.78243 16.1209ZM11.6401 14.7307C11.5557 14.7341 11.4721 14.749 11.3916 14.7749C11.3521 14.7857 11.311 14.797 11.2699 14.8053L23.4867 25.2057L35.7035 14.8053C35.6624 14.797 35.6214 14.7857 35.5818 14.7749C35.5014 14.749 35.4178 14.7341 35.3333 14.7307H11.6401Z",
    fill: "#5B6DC6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_27_7927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2307 38.2099C36.3833 38.2042 35.5566 37.9478 34.8548 37.4729C34.153 36.998 33.6075 36.326 33.2872 35.5415C32.9668 34.757 32.8859 33.8953 33.0547 33.0649C33.2235 32.2345 33.6344 31.4727 34.2356 30.8755C34.8367 30.2783 35.6013 29.8725 36.4328 29.7093C37.2643 29.546 38.1255 29.6327 38.9078 29.9582C39.6901 30.2838 40.3585 30.8338 40.8287 31.5387C41.2989 32.2437 41.5498 33.0721 41.5498 33.9194C41.5446 35.0607 41.087 36.1533 40.2773 36.9577C39.4676 37.762 38.372 38.2123 37.2307 38.2099ZM35.0147 31.2683L35.0119 33.2442L39.2753 33.8087L35.0119 34.3732L35.0147 36.3496L40.9805 33.8087L35.0147 31.2683Z",
    fill: "#BF6087"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27_7927",
    x: -5.02344,
    y: -5.02344,
    width: 70.0469,
    height: 70.0469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.302 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_7927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_7927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_27_7927",
    x: 1.69141,
    y: 9.76953,
    width: 43.5898,
    height: 35.5312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.443137 0 0 0 0 0.443137 0 0 0 0 0.443137 0 0 0 0.251 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_7927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_7927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_27_7927",
    x: 26.9688,
    y: 26.6289,
    width: 20.582,
    height: 20.582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.443137 0 0 0 0 0.443137 0 0 0 0 0.443137 0 0 0 0.251 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_7927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_7927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_7927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendTransactionInitiationEmailsGradient);
export default __webpack_public_path__ + "static/media/send_transaction_initiation_emails_gradient.722e1b99203760bffc1f21ed879b9161.svg";
export { ForwardRef as ReactComponent };